var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflinebedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 34.2143C10.3177 34.2143 12 32.4919 12 30.375C12 28.2581 10.3177 26.5357 8.25 26.5357C6.18234 26.5357 4.5 28.2581 4.5 30.375C4.5 32.4919 6.18234 34.2143 8.25 34.2143ZM24.75 28.0714H14.25C13.8356 28.0714 13.5 28.415 13.5 28.8393V35.75H3V25.7679C3 25.3436 2.66438 25 2.25 25H0.75C0.335625 25 0 25.3436 0 25.7679V42.6607C0 43.085 0.335625 43.4286 0.75 43.4286H2.25C2.66438 43.4286 3 43.085 3 42.6607V40.3571H27V42.6607C27 43.085 27.3356 43.4286 27.75 43.4286H29.25C29.6644 43.4286 30 43.085 30 42.6607V33.4464C30 30.4777 27.6497 28.0714 24.75 28.0714Z",
    fill: "#FD800B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30.7143,
    fill: "white",
    transform: "translate(0 12.2858)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflinebedroom);
export default __webpack_public_path__ + "static/media/offlinebedroom.9e86c80d303c17e8a043d6d79877f491.svg";
export { ForwardRef as ReactComponent };